import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { convertToParam } from '../lib/formatters';

import '../scss/SearchFilter.scss';

const sortFilters = (({ priority: a } = {}, { priority: b } = {}) => (a ?? 0) - (b ?? 0));

const SearchFilter = ({ items, preselect, filters, setFilters }) => {
  const [open, setOpen] = useState(false);

  const toggleFilter = ({ awyesId, id, typeName, name, header }) => {
    if (filters?.[name]) {
      const newFilters = { ...filters };
      delete newFilters[name];
      setFilters(newFilters);
    } else {
      setFilters({ ...(filters ?? {}), [name]: { awyesId, id, typeName, header } });
    }
  };

  useEffect(() => {
    if (preselect?.length && items?.length) {
      const type = items.find(({ name }) => convertToParam(name) === preselect);
      if (type) {
        const newFilters = {
          [type.name]: {
            id: type.id,
            typeName: type.typeName,
            header: type.header,
          }
        };
        setFilters((old) => {
          if (Object.keys(newFilters).sort().join(',') !== Object.keys(old).sort().join(',')) {
            return newFilters;
          } else {
            return old;
          }
        });
      }
    }
  }, [items, preselect, setFilters]);

  const filterCount = Object.keys(filters ?? {}).length;

  return (
    !items?.length ? null :
    <aside className="search-filter">
      <button className="search-filter__button" onClick={() => setOpen(!open)}>Filters{filterCount > 0 ? <span className="search-filter__count">({filterCount})</span> : null}</button>
      <div className={classNames('search-filter__content', {
        'search-filter__content--open': open,
      })}>
        <div className="search-filter__header">
          <span>Filter by:</span>
          { filterCount ? <span className="search-filter__clear-all" onClick={() => setFilters({})}>Clear All</span> : null }
        </div>
        <ul className="search-filter__choices">
          {[...items].sort(sortFilters).map(({ awyesId, id, typeName, name, header }) =>
            <li
              data-awyesid={awyesId}
              key={awyesId}
              className={classNames('search-filter__choice', {
                'search-filter__choice--selected': filters?.[name]
              })}
              onClick={() => toggleFilter({ awyesId, id, typeName, name, header })}
            >
              <span className="search-filter__choice-indicator" />
              <span className="search-filter__choice-label">{name}</span>
            </li>
          )}
        </ul>
        <button className="search-filter__view-items" onClick={() => setOpen(false)}>View Items</button>
      </div>
    </aside>
  );
};

export default SearchFilter;